<header [class.archived]="isArchived">
  <div class="header-left">
    <i class="material-icons-outlined notranslate archive-icon" [class.visible]="isArchived">inventory_2</i>
    <app-inline-editor
      [allowEdit]="true"
      [showEditIcon]="true"
      [viewHeader]="isArchived ? 'Editing Archived Rule:' : 'Editing Rule:'"
      editIconTooltip="Edit Rule name"
      placeholder="New Rule..."
      [headerIcon]="entityIconClass"
      [headerIconTooltip]="entityLabel"
      [formControl]="nameControl">
    </app-inline-editor>
  </div>
  <aside>
    <i class="material-icons copy-icon notranslate header-action-icon"
       [class.disabled]="hasPendingChanges" role="button"
       [attr.aria-label]="hasPendingChanges ? 'Rule needs saving before duplicating' : 'Duplicate ' + data.dataRule.ruleData.name"
       tabindex="0"
       [matTooltip]="hasPendingChanges ? 'Rule needs saving before duplicating' : 'Duplicate ' + data.dataRule.ruleData.name"
       matTooltipPosition="above" [matTooltipShowDelay]="500"
       (click)="onDuplicateClick()"
       (keydown.enter)="onDuplicateClick()"
       (keydown.space)="onDuplicateClick()">content_copy</i>
    <button class="header-action-icon archive-btn"
            [disabled]="isUnsavedRule"
            [attr.aria-label]="isArchived ? 'Unarchive Rule' : 'Archive Rule'"
            [matTooltip]="isArchived ? 'Unarchive Rule' : 'Archive Rule'"
            matTooltipPosition="above" [matTooltipShowDelay]="500"
            (click)="onArchiveClick()">
      <i class="material-icons-outlined notranslate">{{ isArchived ? 'unarchive' : 'inventory_2' }}</i>
    </button>
    <i class="material-icons notranslate header-action-icon" role="button"
       [attr.aria-label]="'Delete ' + data.dataRule.ruleData.name" tabindex="0"
       [matTooltip]="'Delete ' + data.dataRule.ruleData.name"
       matTooltipPosition="above" [matTooltipShowDelay]="500"
       (click)="onDeleteClick()"
       (keydown.enter)="onDeleteClick()"
       (keydown.space)="onDeleteClick()">delete_outline</i>
    <div class="run-controls">
      <ng-container *ffEnabled="'feature_kdata_4249_datarules_record_update_limit'">
        <button #updateLimitButton
                type="button"
                class="header-action-icon update-limit-btn"
                [class.has-limit]="!!updateLimitControl.value"
                [class.open]="isUpdateLimitOpen"
                [class.disabled]="isArchived"
                [attr.aria-disabled]="isArchived"
                aria-label="Update limit"
                aria-haspopup="dialog"
                [attr.aria-expanded]="isUpdateLimitOpen"
                [matTooltip]="updateLimitTooltip"
                [matTooltipDisabled]="isUpdateLimitOpen"
                matTooltipPosition="above" [matTooltipShowDelay]="500"
                (click)="toggleUpdateLimit()">
          <i class="material-icons notranslate">speed</i>
          @if (updateLimitControl.value) {
            <data class="update-limit-badge" aria-hidden="true" [value]="updateLimitControl.value">{{ updateLimitControl.value | compactNumberValues }}</data>
          }
        </button>
      </ng-container>
      <i class="material-icons notranslate header-action-icon"
         [class.disabled]="hasPendingChanges || isArchived  || isEnrichCreditBlocked" role="button"
         [attr.aria-label]="playTooltip"
         tabindex="0"
         [matTooltip]="playTooltip"
         matTooltipPosition="above" [matTooltipShowDelay]="500"
         (click)="onPreviewClick()"
         (keydown.enter)="onPreviewClick()"
         (keydown.space)="onPreviewClick()">play_arrow</i>
    </div>
    <i class="material-icons-outlined notranslate close-dialog"
       role="button"
       aria-label="Close"
       tabindex="0"
       matTooltip="Close"
       matTooltipPosition="above"
       [matTooltipShowDelay]="500"
       (click)="dialogRef.close()"
       (keydown.enter)="dialogRef.close()"
       (keydown.space)="dialogRef.close()">close</i>
  </aside>
</header>

@if (isUpdateLimitOpen) {
  <app-update-limit-popup [control]="updateLimitControl"
                          [ruleEntity]="data.dataRule.ruleData.source?.config?.entity"
                          (closed)="closeUpdateLimit()">
  </app-update-limit-popup>
}

<mat-dialog-content class="scrollable-container">
  <app-rule-folders
    [dataRule]="data.dataRule"
    [ruleIndex]="data.ruleIndex"
    [currentRuleExamples]="isArchived ? null : data.currentRuleExamples"
    (currentRuleExamplesChange)="data.currentRuleExamples = $event"
    [selectedEntity]="data.selectedEntity"
    [tasksRunning]="data.tasksRunning"
    [entityMap]="data.entityMap"
    [savedRuleEvent]="data.savedRuleEvent"
    [nameControl]="nameControl"
    [updateLimitControl]="updateLimitControl"
    [saveTriggered]="saveSubject"
    (ruleSavedEmitter)="onRuleSaved($event)"
    (ruleClickEventEmitter)="dialogRef.close()"
    (canSaveChange)="onCanSaveChange($event)"
    (isDirtyChange)="onPendingChanges($event)">
  </app-rule-folders>
</mat-dialog-content>

<section class="footer-btns mat-mdc-dialog-actions">
  <button mat-button class="danger-btn-hover" (click)="dialogRef.close()" appRipple>{{ hasPendingChanges ? 'CANCEL' : 'CLOSE' }}</button>
  <button mat-button [disabled]="(hasPendingChanges && !canSave) || isEnrichCreditBlocked || isArchived"
          [matTooltip]="isEnrichCreditBlocked ? enrichCreditBlockedTooltip : ''"
          matTooltipPosition="above" [matTooltipShowDelay]="500"
          (click)="onSaveAndPreviewClick()" appRipple>
    <mat-icon>play_arrow</mat-icon>
    {{ (hasPendingChanges || isUnsavedRule) ? 'SAVE AND PREVIEW' : 'PREVIEW' }}
    <mat-icon class="watermark">play_arrow</mat-icon>
  </button>
</section>
